import {STORAGE_URL} from "../../../constants";
export default function CoverFabricForm({ form, setForm, image, setImage, onSubmit, title, buttonLabel }) {
    return (
        <div className="card mt-24">
            <form onSubmit={onSubmit}>
                <div className="card-header border-bottom">
                    <h4 className="mb-4">{title}</h4>
                </div>
                
                <div className="card-body">
                    <div className="row gy-4">
                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Name</label>
                            <input
                                placeholder="Name"
                                name="name"
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                required
                                className="form-control py-11"
                            />
                        </div>

                        <div className="col-sm-6 col-xs-6">
                            <label className="form-label mb-8 h6">Image</label>
                            <input
                                type="file"
                                onChange={(e) => setImage(e.target.files[0])}
                                className="form-control py-11"
                            />
                            {form.image && typeof form.image === "string" && (
                                <img alt="" className="border" src={`${STORAGE_URL}${form.image}`} width="100" />
                            )}
                        </div>
                    
                    
                    
                    <br />
                    <button className="btn btn-main" type="submit">{buttonLabel}</button>
                    </div>
                </div>
            </form>
        </div>
    );
}
